import { createTheme } from "@mui/material/styles";

const palette = {
    primary: {
        light: "#BBC3C7",
        main: "#042231",
    },
    secondary: {
        light: "#CADDF3",
        main: "#3A82D4",
    },
    primaryTertiary: {
        light: "#D2E0EF",
        main: "#588EC3",
    },
    secondaryTertiary: {
        light: "#D9F0F6",
        main: "#73C7DD",
    },
    grey: {
        main: "#231F20",
        light: "#D7DFE9",
    },
};

const theme = createTheme({
    palette,
    buttonPalette: {
        primary: {
            background: palette.primary.main,
            backgroundHover: "#031A26",
            backgroundFocus: palette.primary.main,
            backgroundActive: "#031A26",
            text: "#FFFFFF",
        },
        secondary: {
            background: "#FFFFFF",
            backgroundHover: "#F9FAFB",
            backgroundFocus: "#FFFFFF",
            backgroundActive: "#F9FAFB",
            borderColor: palette.grey.light,
            text: "#455468",
        },
        danger: {
            background: "#E92215",
            backgroundHover: "#D21A0E",
            backgroundFocus: "#E92215",
            backgroundActive: "#D21A0E",
            text: "#FFFFFF",
        },
        disabled: {
            background: palette.grey.light,
            backgroundHover: palette.grey.light,
            backgroundFocus: palette.grey.light,
            backgroundActive: palette.grey.light,
            text: "#FFFFFF",
        },
    },
    buttonSizes: {
        xs: {
            fontSize: "14px",
            paddingX: "12px",
            paddingY: "6px",
            iconSize: "18px",
            iconPaddingX: "10px",
            iconPaddingY: "10px",
        },
        sm: {
            fontSize: "14px",
            paddingX: "15px",
            paddingY: "8px",
            iconSize: "18px",
            iconPaddingX: "12px",
            iconPaddingY: "12px",
        },
        md: {
            fontSize: "16px",
            paddingX: "20px",
            paddingY: "10px",
            iconSize: "18px",
            iconPaddingX: "16px",
            iconPaddingY: "16px",
        },
        lg: {
            fontSize: "18px",
            paddingX: "20px",
            paddingY: "10px",
            iconSize: "20px",
            iconPaddingX: "18px",
            iconPaddingY: "18px",
        },
        xl: {
            fontSize: "18px",
            paddingX: "22px",
            paddingY: "14px",
            iconSize: "24px",
            iconPaddingX: "18px",
            iconPaddingY: "18px",
        },
        "2xl": {
            fontSize: "20px",
            paddingX: "24px",
            paddingY: "16px",
            iconSize: "24px",
            iconPaddingX: "20px",
            iconPaddingY: "20px",
        },
    },
    typography: {
        fontFamily: ["Open Sans"].join(","),
        fontWeightRegular: 400,
        lineHeight: "32px",
        allVariants: {
            color: "#455468",
        },
    },
    letterSpacing: -0.3,
});

export default theme;
